module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component.css
// module chunks = main